<p>
  {{ 'VEHICLE_INFO.TOO_MANY_VEHICLES' | translate:unitInfo }}
</p>

<button class='btn btn-primary parkingpass-nav parkingpass-confirm-button"' (click)="closeDialog()">
  {{ 'BUTTONS.CLOSE' | translate }}
</button>